// src/pages/CheckoutSuccess.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { fetchAuthSession } from 'aws-amplify/auth'
import CircularProgress from '@mui/material/CircularProgress';

export default function CheckoutSuccess() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const sessionId = query.get('session_id');

  useEffect(() => {
    if (!sessionId) {
      // No session ID: redirect to portal
      navigate('/portal');
      return;
    }

    let isActive = true;

    const pollStatus = async () => {
      try {
        const session = await fetchAuthSession();
        const jwt = session?.tokens?.accessToken;
        
        if (!jwt) {
          console.error('No JWT token available for request');
          if (isActive) setTimeout(pollStatus, 2000);
          return;
        }
        
        const url = `${process.env.REACT_APP_USAGE_API}${process.env.REACT_APP_STRIPE_CHECKOUT_STATUS_ID}?session_id=${encodeURIComponent(sessionId)}`
        const response = await fetch(
          url,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${jwt}`
            }
          }
        );
        
        if (!response.ok) {
          console.error('Checkout status check failed:', response.status, await response.text());
          if (isActive) setTimeout(pollStatus, 2000);
          return;
        }
        
        const payload = await response.json();
        const status = payload?.response?.resultData?.status;

        if (!isActive) return;

        if (status === 'complete') {
          navigate('/portal');
        } else if (status === 'failed') {
          // handle failure, e.g., show an error page or toast
          navigate('/upgrade-failed');
        } else {
          // still pending → poll again
          setTimeout(pollStatus, 2000);
        }
      } catch (err) {
        console.error('Polling error:', err);
        if (isActive) setTimeout(pollStatus, 2000);
      }
    };

    pollStatus();
    return () => {
      isActive = false;
    };
  }, [sessionId, navigate]);

  return (
    <div style={{ textAlign: 'center', marginTop: '2rem' }}>
      <CircularProgress />
      <p>Activating your plan…</p>
    </div>
  );
}
